import { VueExtension } from '../../utils/extensions/vue.js';
import List from './list.jsx';
import './list.scss'

VueExtension.WithInstall(List);

export default List;